import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { reorderArray, showAlert } from "../../../config/utils";
import actions from "../actions";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import _ from "lodash";
import qs from "query-string";
import NumberFormat from "react-number-format";
import Dropzone from "react-dropzone";
import ReactTooltip from "react-tooltip";
import ReactSelect from "react-select";
import smartChartActions from "../../smartCharts/actions";
import buildingActions from "../../building/actions";
import OuterDraggable from "react-draggable";
import { downloadPresignedUrlFile } from "../../common/actions";
import { RECOM_FIRST_LEVEL_GROUPING } from "../../smartCharts/constants";
import SelectBox from "../../images/components/SelectBox";
import { EllipsisTooltipText } from "../../common/components/EllipsisTextWithTooltip";
import Loader from "../../common/components/Loader";

const initialState = {
    isLoading: true,
    viewFilter: "all",
    keyList: [],
    searchKey: "",
    alertMessage: "",
    initialValues: {},
    showConfirmationModal: false,
    newFile: {},
    download_file: "",
    exportProperties: [],
    recom_property: "",
    initial_recom_property: "",
    exportTemplates: [],
    selectedFirstLevel: "",
    secondLevelGrouping: [...RECOM_FIRST_LEVEL_GROUPING],
    selectedSecondLevel: "",
    recom_template: "",
    settings_id: "",
    showErrorBorder: false,
    initial_recom_template: "",
    updateLoading: false,
    transform: { left: 0, top: 0 },
    isEditing: false,
    text: "",
    mergeNarrative: false,
    isLegacyExport: false,
    expandedFields: [],
    isSoftCost: false,
    isExportSettingsLoading: false
};
class ViewExportModal extends Component {
    state = initialState;

    getGroupingOptions = () => {
        const { groupingOptions = [], isAssetExportSettingsview = false } = this.props;
        return isAssetExportSettingsview ? groupingOptions : RECOM_FIRST_LEVEL_GROUPING;
    };

    componentDidMount = async () => {
        const {
            location: { search },
            projectIdForSmartChart = "",
            clientIdForSmartChart = "",
            isSmartChartView = false,
            isBuildingView = false,
            isAssetExportSettingsview = false,
            normalRecomConfig,
            smartchartTileKey = "",
            isRegularTableView = false,
            is_smart_chart = false
        } = this.props;
        ReactTooltip.rebuild();

        const query = qs.parse(search);
        await this.setState({
            isLoading: false
        });
        let exportProperties = {};
        let exportTemplates = {};
        let exportSettingData = {};
        let exportFirstLevelData = "";
        let exportSecondLevelData = "";
        let selectedRecomTemplate = null;
        document?.addEventListener("keydown", this.handleKeyDown);
        if (isSmartChartView || isAssetExportSettingsview) {
            let selectedSettingsId = this.props?.smartChartTileConfig?.band1?.settings_id || this.props?.smartChartTileConfig?.settings_id || null;
            await this.setState({ isExportSettingsLoading: true });
            if (smartchartTileKey !== "buildings" && smartchartTileKey !== "additions") {
                await this.props.getExportTemplateListForSmartChartRecom({
                    ...(projectIdForSmartChart ? { project_id: projectIdForSmartChart } : {}),
                    client_id: clientIdForSmartChart
                });
                await this.props.getExportPropertyListForSmartChartRecom({
                    ...(projectIdForSmartChart ? { project_id: projectIdForSmartChart } : {}),
                    client_id: clientIdForSmartChart
                });
            }
            if (isAssetExportSettingsview) {
                let selectedSettingsId =
                    this.props?.smartChartTileConfig?.settings_id ?? this.props?.smartChartTileConfig?.band1?.settings_id ?? null;
                await this.props?.getSmartchartAssetExportSettings({
                    ...(projectIdForSmartChart ? { project_id: projectIdForSmartChart } : {}),
                    client_id: clientIdForSmartChart,
                    ...(selectedSettingsId || normalRecomConfig?.settingsId
                        ? { settings_id: selectedSettingsId || normalRecomConfig?.settingsId }
                        : {}),
                    user_id: localStorage.getItem("userId"),
                    ...(is_smart_chart && { is_smart_chart: true })
                });
                const { AssetExportSettingsData } = this.props.smartChartReducer;
                exportSettingData = AssetExportSettingsData?.data ?? {};
            } else {
                await this.props.getExportSettingsForSmartChartRecom(
                    {
                        project_id: projectIdForSmartChart,
                        settings_id: selectedSettingsId || normalRecomConfig?.settingsId,
                        client_id: clientIdForSmartChart,
                        ...(this.props.isCR && { is_cr: true }),
                        export_type: smartchartTileKey ?? "",
                        ...(isRegularTableView && { user_id: localStorage.getItem("userId") })
                    },
                    smartchartTileKey
                );
                exportSettingData = this.props.smartChartReducer?.exportSettingsData?.data || {};
                if (this.props.smartChartReducer?.exportSettingsData?.message && !this.props.smartChartReducer?.exportSettingsData?.status)
                    await this.setState({ alertMessage: this.props.smartChartReducer?.exportSettingsData?.message }, () => this.showLongAlert());
            }
            exportProperties = this.props.smartChartReducer?.exportPropertyList || "";
            exportTemplates = this.props.smartChartReducer?.exportTemplateList || "";
            if (this.props?.grouping) {
                const groupingFirst =
                    this.props?.smartChartTileConfig?.band1?.grouping_first ||
                    exportSettingData?.config?.grouping_first ||
                    normalRecomConfig?.grouping_first;
                const groupingSecond =
                    this.props?.smartChartTileConfig?.band1?.grouping_second ||
                    exportSettingData?.config?.grouping_second ||
                    normalRecomConfig?.grouping_second;

                if (groupingFirst) {
                    exportFirstLevelData = groupingFirst;
                    exportSecondLevelData = groupingSecond || "";
                } else {
                    const groupingValue =
                        this.props?.smartChartTileConfig?.band1?.grouping || exportSettingData?.config?.grouping || normalRecomConfig?.grouping || "";

                    const [firstLevel = "", secondLevel = ""] = groupingValue.split("_");
                    exportFirstLevelData = firstLevel;
                    exportSecondLevelData = secondLevel;
                }
            }

            let master_templates = [];
            let local_templates = [];
            if (exportTemplates?.without_client?.length) {
                exportTemplates.without_client.forEach(elem => master_templates.push({ value: elem.id, label: elem.name }));
            }
            if (exportTemplates?.with_client?.length) {
                exportTemplates.with_client.forEach(elem => local_templates.push({ value: elem.id, label: elem.name }));
            }
            selectedRecomTemplate = [...master_templates, ...local_templates].find(elem => elem?.value === exportSettingData?.template);
            exportTemplates = [
                {
                    label: "From Local",
                    options: local_templates
                },
                {
                    label: "From Master",
                    options: master_templates
                }
            ];
            await this.setState({ isExportSettingsLoading: false });
        } else if (isBuildingView) {
            const { clientId: client_id } = this.props;
            await this.props.getExportPropertyListForSmartChartRecom({ project_id: query.pid, client_id });
            exportProperties = this.props.smartChartReducer?.exportPropertyList || {};
            await this.props.getExportTemplateListForBuildings({ project_id: query.pid, building_id: this.props.match.params.id, client_id });
            const { getExportPropertyResponse } = this.props.buildingReducer;
            exportSettingData = getExportPropertyResponse?.data ?? {};
        } else {
            await this.setState({ isExportSettingsLoading: true });
            await this.props.getExportPropertyDropdown({
                project_id: projectIdForSmartChart,
                ...(this.props.isCR && { is_cr: true })
            });
            exportProperties = this.props.recommendationsReducer?.exportPropertyList || {};
            if (!exportProperties?.success && exportProperties?.message) {
                await this.setState(
                    {
                        alertMessage: exportProperties?.message
                    },
                    () => this.showLongAlert()
                );
            }
            await this.props.getExportRecom({
                project_id: projectIdForSmartChart,
                client_id: clientIdForSmartChart,
                ...(this.props.isCR && { is_cr: true }),
                ...(this.props?.shouldSaveExportSettingsId ? { settings_id: this.props?.settingsId } : {}),
                ...(is_smart_chart && { is_smart_chart: true })
            });
            exportSettingData = this.props.recommendationsReducer?.getExportItems?.data || {};
            if (!exportSettingData?.success && exportSettingData?.message) {
                await this.setState(
                    {
                        alertMessage: exportSettingData?.message
                    },
                    () => this.showLongAlert()
                );
            }
            await this.setState({ isExportSettingsLoading: false });
        }

        const { properties = [], s3_file, recom_property, template_property, id, config } = exportSettingData;
        let master_props = [];
        let local_props = [];
        if (exportProperties?.without_client?.length) {
            exportProperties.without_client.forEach(elem => master_props.push({ value: elem.id, label: elem.name }));
        }
        if (exportProperties?.with_client?.length) {
            exportProperties.with_client.forEach(elem => local_props.push({ value: elem.id, label: elem.name }));
        }
        const propertyToFind = isAssetExportSettingsview ? template_property : recom_property;
        let selectedRecomProperty = [...master_props, ...local_props].find(elem => elem?.value === propertyToFind);
        exportProperties = [
            {
                label: "From Local",
                options: local_props
            },
            {
                label: "From Master",
                options: master_props
            }
        ];
        const slNoConfig = this.props?.smartChartTileConfig?.band1?.sl_no_config ??
            config?.sl_no_config ??
            normalRecomConfig?.sl_no_config ?? {
                key: "sl_no",
                width: 0.5,
                heading: "Sl No",
                is_active: false,
                heading_alignment: "left",
                body_alignment: "left"
            };
        const isLegacyExport = this.props?.smartChartTileConfig?.band1?.is_legacy ?? config?.is_legacy ?? false;
        this.setState({
            keyList:
                isSmartChartView && smartchartTileKey !== "buildings" && smartchartTileKey !== "additions" ? [slNoConfig, ...properties] : properties,
            download_file: s3_file,
            initialValues: _.cloneDeep(
                isSmartChartView && smartchartTileKey !== "buildings" && smartchartTileKey !== "additions" ? [slNoConfig, ...properties] : properties
            ),
            recom_property: selectedRecomProperty || "",
            initial_recom_property: selectedRecomProperty || "",
            exportProperties,
            exportTemplates: isSmartChartView || isAssetExportSettingsview ? exportTemplates : [],
            settings_id: id,
            recom_template: selectedRecomTemplate || "",
            initial_recom_template: selectedRecomTemplate || "",
            selectedFirstLevel: exportFirstLevelData,
            selectedSecondLevel: exportSecondLevelData,
            secondLevelGrouping: this.getGroupingOptions()?.filter(key => key?.value !== exportFirstLevelData),
            mergeNarrative: this.props?.smartChartTileConfig?.band1?.is_merge_narrative ?? false,
            isLegacyExport,
            intialLegacyExport: isLegacyExport,
            isSoftCost: this.props?.smartChartTileConfig?.band1?.is_soft_cost ?? false
        });
    };

    componentWillUnmount() {
        document?.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = e => {
        if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            this.confirmCancel();
        }
    };
    handleDropdownChange = (event = null) => {
        this.setState({
            viewFilter: event.target.value
        });
    };

    isAllSelected = () => {
        const { keyList } = this.state;
        let count = 0;
        keyList?.forEach(keyItem => {
            if (keyItem["is_active"]) {
                count++;
            }
        });
        if (keyList.length === count) {
            return true;
        }
        return false;
    };

    handleWidth = async (e, keyItem) => {
        const newArray = this.state.keyList;
        const newKeyItem = keyItem?.key
            ? newArray?.findIndex(item => item?.key === keyItem?.key)
            : newArray?.findIndex(item => item?.heading === keyItem?.heading);
        newArray[newKeyItem] = { ...keyItem, width: Number(e) };
        await this.setState({
            keyList: newArray
        });
    };

    handleHideColumn = async keyItem => {
        let updatedList;
        if (keyItem !== "selectAll" && keyItem !== "deselectAll") {
            const newArray = [...this.state.keyList];
            const idx = keyItem.key
                ? newArray.findIndex(item => item.key === keyItem.key)
                : newArray.findIndex(item => item.heading === keyItem.heading);
            newArray[idx] = { ...keyItem, is_active: !keyItem.is_active };
            updatedList = newArray;
        } else {
            updatedList = this.state.keyList.map(item => {
                const isActive = keyItem === "selectAll" ? true : item.key === "sl_no" && !this.props.isSmartChartView ? true : false;
                return { ...item, is_active: isActive };
            });
        }

        const descField = updatedList.find(item => item.key === "description");
        const narrativeField = updatedList.find(item => item.key === "recommendation_narrative");
        const eitherInactive = !descField?.is_active || !narrativeField?.is_active;

        await this.setState({
            keyList: updatedList,
            mergeNarrative: eitherInactive ? false : this.state.mergeNarrative
        });

        return true;
    };

    handleColumn = async keyItem => {
        await this.handleHideColumn(keyItem);
    };

    onEnd = result => {
        if (!result.destination) {
            return;
        }
        const keyList = reorderArray(this.state.keyList, result.source.index, result.destination.index);
        this.setState({
            keyList
        });
    };

    handleSave = async () => {
        const {
            location: { search },
            isSmartChartView = false,
            isBuildingView = false,
            isAssetExportSettingsview = false,
            clientIdForSmartChart,
            grouping: useGrouping,
            isAssetBand = false,
            smartchartTileKey = "",
            isRegularTableView = false,
            shouldSaveExportSettingsId = false,
            projectIdForSmartChart = null,
            is_smart_chart = false,
            create_new = false,
            settingsId = null
        } = this.props;
        const {
            keyList,
            recom_property,
            recom_template,
            settings_id,
            selectedFirstLevel,
            selectedSecondLevel,
            mergeNarrative,
            isLegacyExport,
            newFile,
            isSoftCost
        } = this.state;
        const query = qs.parse(search);
        if (!(isSmartChartView || isBuildingView || isAssetExportSettingsview)) {
            const data = {
                project_id: projectIdForSmartChart || query.pid || this.props.match.params.id,
                recom_property: recom_property?.value || "",
                properties: keyList,
                ...(newFile?.path && { s3_file: newFile }),
                ...(shouldSaveExportSettingsId && settingsId ? { settings_id: settingsId } : { create_new: create_new }),
                is_smart_chart
            };
            this.setState({ updateLoading: true });
            await this.props.postExportRecom(data);
            const { status, message, error = null, detail = null } = this.props.recommendationsReducer.AddExportItems;
            if (status) {
                // save the settings id to the smartchart tile
                if (shouldSaveExportSettingsId && this.props.setExportSettingsData) {
                    this.props.setExportSettingsData({
                        settingsId: this.props.recommendationsReducer.AddExportItems?.data?.id ?? settings_id
                    });
                } else await this.setState({ alertMessage: message, initialValues: keyList }, () => this.showLongAlert());

                this.props.onCancel();
            } else if (error || detail) {
                await this.setState({ alertMessage: error || detail }, () => this.showLongAlert());
            }
            this.setState({ updateLoading: false });
            return;
        }
        if (smartchartTileKey !== "buildings" && smartchartTileKey !== "additions") if (!this.validate()) return;
        let grouping = "";
        if (useGrouping && selectedFirstLevel) {
            grouping = selectedFirstLevel + (selectedSecondLevel ? `_${selectedSecondLevel}` : "");
        }
        const data = {
            recom_property: recom_property?.value || "",
            settings_id
        };
        if (!isBuildingView) {
            data.template = recom_template?.value || "";
        }
        if (isAssetExportSettingsview) {
            data.template_property = recom_property?.value || "";
            data.clientId = clientIdForSmartChart || "";
            data.is_smart_chart = is_smart_chart;
        }

        const slNoConfig = keyList.find(item => item.key === "sl_no") || null;
        const properties = isAssetBand ? keyList : keyList.filter(item => item.key !== "sl_no");
        data.properties = properties;

        if (isRegularTableView) {
            data.config = {
                grouping,
                grouping_first: selectedFirstLevel || "",
                grouping_second: selectedSecondLevel || "",
                sl_no_config: slNoConfig,
                is_legacy: isLegacyExport
            };
        }

        this.setState({ updateLoading: true });
        let status, message;
        try {
            if (!isAssetExportSettingsview) {
                await this.props.saveExportSettingsForSmartChartRecom({ ...data, export_type: smartchartTileKey ?? "" }, smartchartTileKey);
                ({ status, message } = this.props.smartChartReducer.saveExportSettingsData);
            } else {
                await this.props.saveExportSettingsForSmartChartAsset(data);
                ({ status, message } = this.props.smartChartReducer.saveAssetExportSettingsData);
            }
        } finally {
            this.setState({ updateLoading: false });
        }

        if (status) {
            await this.setState({ alertMessage: message, initialValues: properties }, () => this.showLongAlert());

            if (!isBuildingView) {
                this.props.setNormalRecomData({
                    settingsId: settings_id,
                    groupingData: grouping,
                    groupingFirst: selectedFirstLevel || "",
                    groupingSecond: selectedSecondLevel || "",
                    isGrouping: useGrouping,
                    mergeNarrative,
                    slNoConfig,
                    isLegacyExport,
                    includeProjectCost: isSoftCost
                });
            }

            this.props.onCancel();
        }
    };

    handleDownloadWord = () => {
        const { download_file } = this.state;
        if (download_file) {
            downloadPresignedUrlFile(download_file);
        }
    };

    showLongAlert = () => showAlert(this.state.alertMessage, true);

    confirmCancel = () => {
        const { initialValues, keyList, newFile, initial_recom_property, recom_property, initial_recom_template, recom_template } = this.state;
        if (
            _.isEqual(initialValues, keyList) &&
            _.isEqual(initial_recom_property, recom_property) &&
            !newFile?.path &&
            _.isEqual(initial_recom_template, recom_template) &&
            _.isEqual(this.state?.intialLegacyExport, this.state?.isLegacyExport)
        ) {
            this.props.onCancel();
        } else {
            this.setState({
                showConfirmationModal: true
            });
        }
    };
    renderConfirmationModal = () => {
        const { showConfirmationModal } = this.state;
        if (!showConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to clear and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => this.setState({ showConfirmationModal: false })}
                        onYes={() => {
                            this.setState(initialState);
                            this.props.onCancel();
                        }}
                        cancel={() => this.setState({ showConfirmationModal: false })}
                    />
                }
                onCancel={() => this.setState({ showConfirmationModal: false })}
            />
        );
    };

    validate = () => {
        const { recom_property, recom_template } = this.state;
        const { isBuildingView = false, isAssetExportSettingsview = false } = this.props;
        let showErrorBorder = false;
        if (!isAssetExportSettingsview) {
            if (!recom_property?.value?.trim()?.length) {
                showErrorBorder = true;
            } else if (!recom_template?.value?.trim()?.length) {
                if (!isBuildingView) showErrorBorder = true;
            }
        }
        this.setState({ showErrorBorder });
        if (showErrorBorder) return false;
        return true;
    };

    handleSelectExportProperty = async value => {
        const {
            isSmartChartView,
            projectIdForSmartChart,
            location: { search },
            isBuildingView,
            isAssetExportSettingsview = false,
            clientIdForSmartChart,
            selectedSettingsId,
            smartchartTileKey = "",
            is_smart_chart = false
        } = this.props;

        this.setState({ recom_property: value });
        if (isSmartChartView) {
            await this.props.getExportSettingsForSmartChartRecom({
                project_id: projectIdForSmartChart,
                recom_property_id: value?.value || null,
                ...(this.props.isCR && { is_cr: true })
            });
            let exportSettingData = this.props.smartChartReducer?.exportSettingsData || {};
            const { properties = [] } = exportSettingData;
            let slNoConfig = {
                key: "sl_no",
                width: 0.5,
                heading: "Sl No",
                is_active: false,
                heading_alignment: "left",
                body_alignment: "left"
            };
            this.setState({
                keyList:
                    isSmartChartView && smartchartTileKey !== "buildings" && smartchartTileKey !== "additions"
                        ? [slNoConfig, ...properties]
                        : properties,
                initialValues: _.cloneDeep(properties),
                expandedFields: []
            });
        }
        if (!isSmartChartView && !isBuildingView) {
            await this.setState({ isExportSettingsLoading: true });
            const query = qs.parse(search);
            let exportSettingData = {};
            if (isAssetExportSettingsview) {
                await this.props?.getSmartchartAssetExportSettings({
                    project_id: query.pid || this.props.match.params.id || projectIdForSmartChart,
                    client_id: clientIdForSmartChart,
                    // settings_id: selectedSettingsId || this.props?.normalRecomConfig?.settingsId,
                    asset_property_id: value?.value
                });
                const { AssetExportSettingsData } = this.props.smartChartReducer;
                exportSettingData = AssetExportSettingsData ?? {};
            } else {
                await this.props.getExportRecom({
                    project_id: projectIdForSmartChart,
                    property_id: value?.value,
                    ...(this.props.isCR && { is_cr: true })
                });
                exportSettingData = this.props.recommendationsReducer.getExportItems.data || {};
            }

            const { properties = [] } = exportSettingData;
            this.setState({
                keyList: properties,
                initialValues: _.cloneDeep(properties),
                expandedFields: []
            });
            await this.setState({ isExportSettingsLoading: false });
        }
    };
    handleDrag = (e, ui) => {
        const { x, y } = ui;
        this.setState({
            transform: {
                left: x,
                top: y
            }
        });
        this.props?.isDraggable && this.props?.isDraggable(false);
    };
    handleFirstLevelChange = e => {
        this.setState({
            selectedFirstLevel: e,
            selectedSecondLevel: "",
            secondLevelGrouping: this.getGroupingOptions()?.filter(key => key?.value !== e)
        });
    };
    handleLabelClick = keyItem => {
        this.setState({ isEditing: keyItem?.key });
        this.setState({ text: keyItem["heading"] });
    };

    handleTextChange = (e, keyItem) => {
        this.setState({ text: e });
    };

    handleBlur = keyItem => {
        if (this.state.text?.trim()?.length) {
            const newArray = [...this.state?.keyList];
            const insertIndex = newArray?.findIndex(item => item?.key === keyItem?.key);
            newArray[insertIndex] = { ...keyItem, heading: this.state.text };
            this.setState({
                keyList: newArray
            });
        } else {
            showAlert("Label shouldn't be empty!");
        }
        this.setState({ isEditing: false });
    };

    toggleCollapse = key => {
        this.setState(prevState => {
            const { expandedFields } = prevState;
            if (expandedFields.includes(key)) {
                return {
                    expandedFields: expandedFields.filter(k => k !== key)
                };
            } else {
                return {
                    expandedFields: [...expandedFields, key]
                };
            }
        });
    };

    handleAlignmentChange = async (type, value, keyItem) => {
        const newArray = [...this.state.keyList];
        const index = keyItem?.key
            ? newArray.findIndex(item => item?.key === keyItem.key)
            : newArray.findIndex(item => item?.heading === keyItem.heading);

        if (index !== -1) {
            newArray[index] = {
                ...newArray[index],
                [type]: value
            };

            await this.setState({
                keyList: newArray
            });
        }
    };

    render() {
        const {
            keyList,
            viewFilter,
            download_file,
            newFile,
            exportProperties,
            recom_property,
            exportTemplates,
            recom_template,
            showErrorBorder,
            updateLoading,
            isEditing,
            text
        } = this.state;
        const {
            isSmartChartView = false,
            isBuildingView = false,
            isAssetExportSettingsview = false,
            isSmartchartRecommendation = false,
            viewOnly = false,
            smartChartReducer: { exportSettingsData },
            hasNoLegacyExport = false,
            hasNoExportDropdowns = false,
            heading = "",
            smartchartTileKey = "",
            isRegularTableView = false,
            hasNoTemplateDropdown = false
        } = this.props;

        let KeyLists =
            viewFilter === "all"
                ? keyList
                : viewFilter === "visible"
                  ? keyList.filter(item => item.is_active === true)
                  : viewFilter === "notVisible"
                    ? keyList.filter(item => item.is_active === false)
                    : keyList;
        let file_name_recommendation = download_file?.split("/");
        file_name_recommendation = file_name_recommendation ? file_name_recommendation[file_name_recommendation?.length - 1] : "";

        const descriptionField = keyList.find(field => field.key === "description");
        const narrativeField = keyList.find(field => field.key === "recommendation_narrative");

        const disableMergeNarrative = viewOnly || !descriptionField?.is_active || !narrativeField?.is_active;
        const hasNoStyleDropdown = smartchartTileKey === "buildings" || smartchartTileKey === "additions" ? true : false;
        const hasFileDroppable = !(isSmartChartView || isBuildingView || isAssetExportSettingsview);
        const hasExportTemplateDropdown = (isSmartChartView || isAssetExportSettingsview) && !hasNoExportDropdowns && !hasNoTemplateDropdown;
        return (
            <React.Fragment>
                <div
                    className={`modal modal-region modal-view reco-view-mdl ${isSmartchartRecommendation ? "" : "export-system-recom"}`}
                    id="modalId"
                    style={{ display: "block" }}
                    tabIndex="-1"
                >
                    {this.renderConfirmationModal()}
                    <div className="modal-dialog" role="document">
                        <OuterDraggable
                            handle=".draggable"
                            cancel=".not-draggable"
                            onDrag={this.handleDrag}
                            onStart={this.props?.isDraggable && this.props?.isDraggable(true)}
                        >
                            <div className="modal-content outerModal_draggable" style={this.state.transform}>
                                <div className="modal-header draggable">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        <div className="txt-hed">{heading || "Export Settings"}</div>
                                        <div className="selct-otr">
                                            <select
                                                className="form-control"
                                                onChange={e => this.handleDropdownChange(e)}
                                                value={this.state.viewFilter}
                                            >
                                                <option value="all">All</option>
                                                <option value="visible">Visible</option>
                                                <option value="notVisible">Not Visible</option>
                                            </select>
                                        </div>
                                    </h5>
                                    <button type="button" className="close" onClick={this.confirmCancel}>
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="" />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body region-otr draggable">
                                    <DragDropContext onDragEnd={this.onEnd}>
                                        <Droppable droppableId="droppable">
                                            {provided => (
                                                <div ref={provided.innerRef} className="col-md-12 check-otr d-flex checkbox-sec not-draggable">
                                                    {hasFileDroppable ? (
                                                        <Dropzone
                                                            accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword"
                                                            onDrop={acceptedFiles => {
                                                                this.setState({ newFile: acceptedFiles[0] });
                                                            }}
                                                            multiple={false}
                                                            disabled={viewOnly}
                                                        >
                                                            {({ getRootProps, getInputProps }) => (
                                                                <section
                                                                    className="drag-otr col-md-12"
                                                                    {...getRootProps()}
                                                                    style={{
                                                                        cursor: viewOnly ? "not-allowed" : "pointer"
                                                                    }}
                                                                >
                                                                    <img src="/img/download-icon-upload.svg" alt="" />
                                                                    <div>
                                                                        <input {...getInputProps()} />
                                                                        <h3 class="drag-txt">{`Drag and drop file here or click to ${
                                                                            file_name_recommendation ? "change" : "select"
                                                                        } file`}</h3>
                                                                        <p class="doc-name">
                                                                            {newFile?.path || file_name_recommendation || "Supports Docx"}
                                                                        </p>
                                                                    </div>
                                                                </section>
                                                            )}
                                                        </Dropzone>
                                                    ) : null}

                                                    {hasExportTemplateDropdown ? (
                                                        <div className="col-md-12 box-otr box-wide">
                                                            <div className="">
                                                                <label className="container-check pl-0 mb-0">Export Template</label>
                                                            </div>
                                                            <div className="export-property-select-box">
                                                                <ReactSelect
                                                                    options={exportTemplates}
                                                                    value={recom_template}
                                                                    isClearable
                                                                    classNamePrefix="react-select"
                                                                    onChange={value => this.setState({ recom_template: value })}
                                                                    isSearchable={false}
                                                                    className={`${
                                                                        (isSmartChartView || isAssetExportSettingsview) &&
                                                                        showErrorBorder &&
                                                                        !recom_template?.value?.trim().length
                                                                            ? "error-border "
                                                                            : ""
                                                                    } ${viewOnly ? "cursor-disabled" : ""}`}
                                                                    isDisabled={viewOnly}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {!hasNoExportDropdowns && (
                                                        <div className="col-md-12 box-otr box-wide">
                                                            <div className="">
                                                                <label className="container-check pl-0 mb-0">Export Property</label>
                                                            </div>
                                                            <div className="export-property-select-box">
                                                                {/* <select
                                                            autoComplete="off"
                                                            name=""
                                                            className={`custom-selecbox form-control`}
                                                            onChange={e => this.setState({ recom_property: e.target.value })}
                                                            value={recom_property}
                                                        >
                                                            <option value="">Select</option>
                                                            {exportProperties.map(item => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select> */}

                                                                <ReactSelect
                                                                    options={exportProperties}
                                                                    value={recom_property}
                                                                    isClearable
                                                                    classNamePrefix="react-select"
                                                                    onChange={value => this.handleSelectExportProperty(value)}
                                                                    isSearchable={false}
                                                                    className={`${
                                                                        (isSmartChartView || isBuildingView || isAssetExportSettingsview) &&
                                                                        showErrorBorder &&
                                                                        !recom_property?.value?.trim().length
                                                                            ? "error-border "
                                                                            : ""
                                                                    } ${viewOnly ? "cursor-disabled" : ""}`}
                                                                    isDisabled={viewOnly}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {this.props?.grouping && (
                                                        <div className="d-flex col-md-12 pl-0 pr-3">
                                                            <div className="otr-form p-0 d-flex mt-3 col-md-6 mr-3">
                                                                <div className="selct-otr col-12 p-0">
                                                                    <SelectBox
                                                                        label="First Level Grouping"
                                                                        value={this.state.selectedFirstLevel}
                                                                        handleChange={e => this.handleFirstLevelChange(e)}
                                                                        optionsList={this.getGroupingOptions()}
                                                                        isGrouping
                                                                        disabled={viewOnly}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="otr-form p-0 d-flex mt-3 col-md-6 mr-3">
                                                                <div className="selct-otr col-12 p-0">
                                                                    <SelectBox
                                                                        label="Second Level Grouping"
                                                                        value={this.state.selectedSecondLevel}
                                                                        handleChange={e => {
                                                                            this.setState({ selectedSecondLevel: e });
                                                                        }}
                                                                        optionsList={this.state?.secondLevelGrouping}
                                                                        disabled={
                                                                            !this.state.selectedFirstLevel ||
                                                                            !this.state?.secondLevelGrouping?.length ||
                                                                            viewOnly
                                                                        }
                                                                        isGrouping
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {this.props.hasMergeNarrativeCheckbox && (
                                                        <div className="col-md-12 box-otr box-wide">
                                                            <div className="rem-txt">
                                                                <label
                                                                    className={`container-check ${disableMergeNarrative ? "cursor-disabled" : ""}`}
                                                                >
                                                                    Merge Narrative into Recommendation Field
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.mergeNarrative}
                                                                        onChange={() => this.setState({ mergeNarrative: !this.state.mergeNarrative })}
                                                                        disabled={disableMergeNarrative}
                                                                    />
                                                                    <span className={`checkmark`} />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {isSmartChartView && !hasNoLegacyExport && (
                                                        <>
                                                            <div className="col-md-12 box-otr box-wide">
                                                                <div className="rem-txt">
                                                                    <label className={`container-check`}>
                                                                        Legacy Export
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state.isLegacyExport}
                                                                            onChange={() =>
                                                                                this.setState({ isLegacyExport: !this.state.isLegacyExport })
                                                                            }
                                                                        />
                                                                        <span className={`checkmark`} />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            {!isRegularTableView && (
                                                                <div className="col-md-12 box-otr box-wide">
                                                                    <div className="rem-txt">
                                                                        <label className={`container-check`}>
                                                                            Include Project Cost Total
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.isSoftCost}
                                                                                onChange={() => this.setState({ isSoftCost: !this.state.isSoftCost })}
                                                                            />
                                                                            <span className={`checkmark`} />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                    <div className="col-md-12 p-0 d-flex">
                                                        {viewFilter === "all" ? (
                                                            <div className="col-md-4 box-otr">
                                                                <div className="rem-txt">
                                                                    <label className="container-check">
                                                                        Select All
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.isAllSelected()}
                                                                            onChange={() =>
                                                                                this.handleColumn(this.isAllSelected() ? "deselectAll" : "selectAll")
                                                                            }
                                                                            disabled={viewOnly}
                                                                        />
                                                                        <span className={`checkmark ${viewOnly ? "cursor-disabled" : ""}`} />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                        <div className={`${viewFilter === "all" ? "col-md-8" : "col-md-12"} formInp search pl-0`}>
                                                            <i className="fas fa-search" />
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={async e => {
                                                                    await this.setState({
                                                                        searchKey: e.target.value
                                                                    });
                                                                }}
                                                                value={this.state.searchKey}
                                                                placeholder="Search Columns"
                                                            />
                                                        </div>
                                                    </div>
                                                    {exportSettingsData?.loading || this.state?.isExportSettingsLoading ? (
                                                        <div className="col-md-12 text-center mt-5 mb-3">
                                                            <Loader />
                                                        </div>
                                                    ) : KeyLists?.length ? (
                                                        KeyLists?.filter(keyItem => {
                                                            let isTrue = true;
                                                            if (this.state.searchKey) {
                                                                isTrue = keyItem["heading"]
                                                                    ?.toString()
                                                                    ?.toLowerCase()
                                                                    ?.includes(this.state.searchKey?.toLowerCase());
                                                            }
                                                            if (isTrue && this.state.viewFilter === "visible") {
                                                                isTrue = keyItem["is_active"] === true;
                                                            } else if (isTrue && this.state.viewFilter === "notVisible") {
                                                                isTrue = keyItem["is_active"] === false;
                                                            }
                                                            return isTrue;
                                                        }).map((keyItem, i) => (
                                                            <>
                                                                {["sl_no"].includes(keyItem["key"]) ? (
                                                                    <>
                                                                        <div
                                                                            className={`col-md-12 box-otr box-wide ${
                                                                                this.state.expandedFields.includes(keyItem.key) ? "box-expanded" : ""
                                                                            }`}
                                                                        >
                                                                            <div className="rem-txt d-flex">
                                                                                <label className="container-check">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={isSmartChartView ? keyItem["is_active"] : true}
                                                                                        disabled={!isSmartChartView || viewOnly}
                                                                                        onChange={() => this.handleColumn(keyItem)}
                                                                                    />
                                                                                    <span
                                                                                        className={`checkmark ${
                                                                                            !isSmartChartView ? "cursor-disabled" : ""
                                                                                        }`}
                                                                                    />
                                                                                </label>
                                                                                {isEditing === keyItem?.key ? (
                                                                                    <div className="analyse-field">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={text}
                                                                                            onChange={e =>
                                                                                                this.handleTextChange(e.target.value, keyItem)
                                                                                            }
                                                                                            onBlur={() => this.handleBlur(keyItem)}
                                                                                            autoFocus
                                                                                            onClick={e => {
                                                                                                e.stopPropagation();
                                                                                            }}
                                                                                            onKeyDown={event => {
                                                                                                if (event.key === "Enter") {
                                                                                                    this.handleBlur(keyItem);
                                                                                                }
                                                                                            }}
                                                                                            className="form-control"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <label
                                                                                        className="container-check pl-2 d-flex align-items-center"
                                                                                        onClick={e => {
                                                                                            if (!keyItem?.is_year) {
                                                                                                e.stopPropagation();
                                                                                                this.handleLabelClick(keyItem);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <EllipsisTooltipText
                                                                                            className="line-clamp"
                                                                                            text={keyItem["heading"]}
                                                                                        />
                                                                                        <i
                                                                                            className="fas fa-pencil-alt ml-auto mr-2 edit-icon"
                                                                                            role="button"
                                                                                            title="Rename"
                                                                                            onClick={e => {
                                                                                                if (!keyItem?.is_year && !viewOnly) {
                                                                                                    e.stopPropagation();
                                                                                                    this.handleLabelClick(keyItem);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </label>
                                                                                )}
                                                                            </div>
                                                                            <div className="right-box-content">
                                                                                <div class="input-box">
                                                                                    <NumberFormat
                                                                                        autoComplete={"nope"}
                                                                                        className="custom-input form-control"
                                                                                        value={keyItem["width"]}
                                                                                        suffix={" inch"}
                                                                                        thousandSeparator={true}
                                                                                        onValueChange={values => {
                                                                                            const { value } = values;
                                                                                            this.handleWidth(value, keyItem);
                                                                                        }}
                                                                                        disabled={viewOnly}
                                                                                    />
                                                                                </div>
                                                                                <div className="image-drag">
                                                                                    <img src="/img/Group 2.svg" alt="" />
                                                                                </div>
                                                                                <button
                                                                                    className="btn btn-link p-0 ml-2"
                                                                                    type="button"
                                                                                    onClick={() => this.toggleCollapse(keyItem.key)}
                                                                                    aria-expanded={this.state.expandedFields.includes(keyItem.key)}
                                                                                    aria-controls={`collapse-${keyItem.key}`}
                                                                                >
                                                                                    <i
                                                                                        className={`fas fa-chevron-${
                                                                                            this.state.expandedFields.includes(keyItem.key)
                                                                                                ? "up"
                                                                                                : "down"
                                                                                        }`}
                                                                                    />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className={`col-md-12 collapse ${
                                                                                this.state.expandedFields.includes(keyItem.key) ? "show" : ""
                                                                            }`}
                                                                            id={`collapse-${keyItem.key}`}
                                                                        >
                                                                            <div className="row py-2 alignment-wrapper">
                                                                                <div className="col-md-6">
                                                                                    <label>Heading Alignment</label>
                                                                                    <select
                                                                                        value={keyItem.heading_alignment || "left"}
                                                                                        onChange={e =>
                                                                                            this.handleAlignmentChange(
                                                                                                "heading_alignment",
                                                                                                e.target.value,
                                                                                                keyItem
                                                                                            )
                                                                                        }
                                                                                        disabled={this.props.viewOnly}
                                                                                        className="form-control mb-2"
                                                                                    >
                                                                                        <option value="left">Left</option>
                                                                                        <option value="center">Center</option>
                                                                                        <option value="right">Right</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <label>Body Alignment</label>
                                                                                    <select
                                                                                        value={keyItem.body_alignment || "left"}
                                                                                        onChange={e =>
                                                                                            this.handleAlignmentChange(
                                                                                                "body_alignment",
                                                                                                e.target.value,
                                                                                                keyItem
                                                                                            )
                                                                                        }
                                                                                        disabled={this.props.viewOnly}
                                                                                        className="form-control"
                                                                                    >
                                                                                        <option value="left">Left</option>
                                                                                        <option value="center">Center</option>
                                                                                        <option value="right">Right</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <Draggable
                                                                        key={i}
                                                                        draggableId={`draggable-${i}`}
                                                                        index={i}
                                                                        isDragDisabled={viewOnly}
                                                                    >
                                                                        {provided => (
                                                                            <>
                                                                                <div
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                    key={`draggable-${i}`}
                                                                                    className={`col-md-12 box-otr box-wide ${
                                                                                        this.state.expandedFields.includes(keyItem.key)
                                                                                            ? "box-expanded"
                                                                                            : ""
                                                                                    }`}
                                                                                    onClick={() => {
                                                                                        if (isEditing !== null) {
                                                                                            this.setState({ isEditing: null });
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <div className="rem-txt d-flex">
                                                                                        <label className="container-check">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={keyItem["is_active"]}
                                                                                                onChange={() => this.handleColumn(keyItem)}
                                                                                                disabled={viewOnly}
                                                                                            />
                                                                                            <span
                                                                                                className={`checkmark ${
                                                                                                    viewOnly ? "cursor-disabled" : ""
                                                                                                }`}
                                                                                            />
                                                                                        </label>
                                                                                        {isEditing === keyItem?.key ? (
                                                                                            <div className="analyse-field">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    value={text}
                                                                                                    onChange={e =>
                                                                                                        this.handleTextChange(e.target.value, keyItem)
                                                                                                    }
                                                                                                    onBlur={() => this.handleBlur(keyItem)}
                                                                                                    autoFocus
                                                                                                    onClick={e => {
                                                                                                        e.stopPropagation();
                                                                                                    }}
                                                                                                    onKeyDown={event => {
                                                                                                        if (event.key === "Enter") {
                                                                                                            this.handleBlur(keyItem);
                                                                                                        }
                                                                                                    }}
                                                                                                    className="form-control"
                                                                                                />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <label
                                                                                                className="container-check pl-2 d-flex align-items-center"
                                                                                                onClick={e => {
                                                                                                    if (!keyItem?.is_year && !viewOnly) {
                                                                                                        e.stopPropagation();
                                                                                                        this.handleLabelClick(keyItem);
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                <EllipsisTooltipText
                                                                                                    className="line-clamp"
                                                                                                    text={keyItem["heading"] ?? "fayis"}
                                                                                                />
                                                                                                {!keyItem?.is_year && (
                                                                                                    <i
                                                                                                        className="fas fa-pencil-alt ml-auto mr-2 edit-icon"
                                                                                                        role="button"
                                                                                                        title="Rename"
                                                                                                        onClick={e => {
                                                                                                            if (!keyItem?.is_year && !viewOnly) {
                                                                                                                e.stopPropagation();
                                                                                                                this.handleLabelClick(keyItem);
                                                                                                            }
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </label>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="right-box-content">
                                                                                        {keyItem.key === "image" ? (
                                                                                            <div class="input-box">
                                                                                                <i
                                                                                                    className="fa fa-info"
                                                                                                    data-for="property-info"
                                                                                                    data-tip={
                                                                                                        "The width of the image column is determined by the image width specified in the selected export property"
                                                                                                    }
                                                                                                />
                                                                                                <ReactTooltip
                                                                                                    id="property-info"
                                                                                                    className="rc-tooltip-custom-class"
                                                                                                    backgroundColor="#007bff"
                                                                                                    effect="solid"
                                                                                                />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div class="input-box">
                                                                                                <NumberFormat
                                                                                                    autoComplete={"nope"}
                                                                                                    className="custom-input form-control"
                                                                                                    value={keyItem["width"]}
                                                                                                    suffix={" inch"}
                                                                                                    thousandSeparator={true}
                                                                                                    onValueChange={values => {
                                                                                                        const { value } = values;
                                                                                                        this.handleWidth(value, keyItem);
                                                                                                    }}
                                                                                                    disabled={
                                                                                                        viewOnly ||
                                                                                                        smartchartTileKey === "buildings" ||
                                                                                                        smartchartTileKey === "additions"
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        <div className="image-drag">
                                                                                            <img src="/img/Group 2.svg" alt="" />
                                                                                        </div>
                                                                                        {!hasNoStyleDropdown ? (
                                                                                            <button
                                                                                                className="btn btn-link p-0 ml-2"
                                                                                                type="button"
                                                                                                onClick={() => this.toggleCollapse(keyItem.key)}
                                                                                                aria-expanded={this.state.expandedFields.includes(
                                                                                                    keyItem.key
                                                                                                )}
                                                                                                aria-controls={`collapse-${keyItem.key}`}
                                                                                            >
                                                                                                <i
                                                                                                    className={`fas fa-chevron-${
                                                                                                        this.state.expandedFields.includes(
                                                                                                            keyItem.key
                                                                                                        )
                                                                                                            ? "up"
                                                                                                            : "down"
                                                                                                    }`}
                                                                                                />
                                                                                            </button>
                                                                                        ) : null}
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className={`col-md-12 collapse ${
                                                                                        this.state.expandedFields.includes(keyItem.key) ? "show" : ""
                                                                                    }`}
                                                                                    id={`collapse-${keyItem.key}`}
                                                                                >
                                                                                    <div className="row py-2 alignment-wrapper">
                                                                                        <div className="col-md-6">
                                                                                            <label>Heading Alignment</label>
                                                                                            <select
                                                                                                value={keyItem.heading_alignment || "left"}
                                                                                                onChange={e =>
                                                                                                    this.handleAlignmentChange(
                                                                                                        "heading_alignment",
                                                                                                        e.target.value,
                                                                                                        keyItem
                                                                                                    )
                                                                                                }
                                                                                                disabled={this.props.viewOnly}
                                                                                                className="form-control mb-2"
                                                                                            >
                                                                                                <option value="left">Left</option>
                                                                                                <option value="center">Center</option>
                                                                                                <option value="right">Right</option>
                                                                                            </select>
                                                                                        </div>
                                                                                        <div className="col-md-6">
                                                                                            <label>Body Alignment</label>
                                                                                            <select
                                                                                                value={keyItem.body_alignment || "left"}
                                                                                                onChange={e =>
                                                                                                    this.handleAlignmentChange(
                                                                                                        "body_alignment",
                                                                                                        e.target.value,
                                                                                                        keyItem
                                                                                                    )
                                                                                                }
                                                                                                disabled={this.props.viewOnly}
                                                                                                className="form-control"
                                                                                            >
                                                                                                <option value="left">Left</option>
                                                                                                <option value="center">Center</option>
                                                                                                <option value="right">Right</option>
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </Draggable>
                                                                )}
                                                            </>
                                                        ))
                                                    ) : (
                                                        <div className="col-md-12 text-center mt-5">No records found!</div>
                                                    )}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                    <div class="col-md-12 p-0 mt-4 text-right btnOtr d-flex col-md-12 not-draggable">
                                        {download_file?.length ? (
                                            <div className="col-md-2 p-0 text-center">
                                                <button
                                                    onClick={this.handleDownloadWord}
                                                    className="btn-download"
                                                    data-place="top"
                                                    data-tip={"Download Uploaded Template"}
                                                    data-for="export"
                                                >
                                                    <img src="/img/file-download.svg" alt="" />
                                                    <ReactTooltip id="export" effect="solid" />
                                                </button>
                                            </div>
                                        ) : null}
                                        {!viewOnly && (
                                            <div className="tot-btr">
                                                <button
                                                    type="button"
                                                    onClick={this.confirmCancel}
                                                    className="btn btn-secondary btnClr col-md-3 mr-1"
                                                    data-dismiss="modal"
                                                >
                                                    Cancel
                                                </button>
                                                <button type="button" onClick={this.handleSave} className="btn btn-primary btnRgion btn-wid">
                                                    Save
                                                    {updateLoading ? (
                                                        <span className="spinner-border spinner-border-sm pl-2 ml-2" role="status"></span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </OuterDraggable>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { recommendationsReducer, smartChartReducer, buildingReducer } = state;
    return { recommendationsReducer, smartChartReducer, buildingReducer };
};
const {
    getExportPropertyListForSmartChartRecom,
    getExportTemplateListForSmartChartRecom,
    getExportSettingsForSmartChartRecom,
    saveExportSettingsForSmartChartRecom,
    getSmartchartAssetExportSettings,
    getExportPropertyListForSmartChartAsset,
    getExportTemplateListForSmartChartAsset,
    saveExportSettingsForSmartChartAsset
} = smartChartActions;

const { getExportTemplateListForBuildings } = buildingActions;

export default withRouter(
    connect(mapStateToProps, {
        ...actions,
        getExportPropertyListForSmartChartRecom,
        getExportTemplateListForSmartChartRecom,
        getExportSettingsForSmartChartRecom,
        saveExportSettingsForSmartChartRecom,
        getExportTemplateListForBuildings,
        getSmartchartAssetExportSettings,
        getExportPropertyListForSmartChartAsset,
        getExportTemplateListForSmartChartAsset,
        saveExportSettingsForSmartChartAsset
    })(ViewExportModal)
);
